var React = require('react');

function PropertyLightGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.83 6.301l5.589 4.629a.5.5 0 0 1 .181.385v7.684a.5.5 0 0 1-.5.5h-3.522a.5.5 0 0 1-.5-.5v-2.166a.5.5 0 0 0-.5-.5H11.42a.5.5 0 0 0-.5.5v2.166a.5.5 0 0 1-.5.5H6.9a.5.5 0 0 1-.5-.5v-7.684a.5.5 0 0 1 .182-.385l5.611-4.63a.5.5 0 0 1 .637.001zM6.4 6v3.114l3.284-2.716V6a.5.5 0 0 0-.5-.5H6.9a.5.5 0 0 0-.5.5z","fill":"#BEBDB8"}));
}

PropertyLightGrey.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = PropertyLightGrey;

PropertyLightGrey.default = PropertyLightGrey;
